import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Store } from '../../../../types';
import { Box, Typography } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

type Props = {
  onDelete: (userId: number) => void;
  onClose: () => void;
};
export const DeleteUserModal: FC<Props> = ({ onClose, onDelete }) => {
  const { t } = useTranslation();

  const { chosenUser } = useSelector((state: Store) => state.users);

  const onSubmit = () => {
    onDelete(Number(chosenUser?.id));
  };

  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': { mb: 1, mt: 1 },
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off">
      <Typography>Are you sure you want to delete user {chosenUser?.username}</Typography>
      <DialogActions>
        <Button onClick={onClose}>{t('general.cancel')}</Button>
        <Button onClick={onSubmit}>{t('general.save')}</Button>
      </DialogActions>
    </Box>
  );
};
